const stringifyData = (value: string | object | null) =>
  typeof value === 'object'
    ? JSON.stringify(value, (_, v) =>
        typeof v === 'bigint' ? v.toString() : v,
      )
    : value;

export default stringifyData;
